import { LOOM_SDK_API_KEY } from 'constants/runtimeConfig';

class RecordSDKPersistentRecordBuilder {
  instance = undefined;
  promise = undefined;

  constructor() {
    this.promise = import('@loomhq/loom-sdk')
      .then(module => {
        const { setup } = module;

        return setup({
          apiKey: LOOM_SDK_API_KEY,
          config: { disablePreviewModal: true, enableOnboardingTutorial: true },
        });
      })
      .then(result => result);
  }

  async waitOnInstance() {
    if (this.instance) {
      return this.instance;
    }

    const result = await this.promise;

    this.instance = result;

    return result;
  }
}

let sdkInstance;

function getSDKInstance() {
  if (!sdkInstance) {
    sdkInstance = new RecordSDKPersistentRecordBuilder();
  }

  return sdkInstance;
}

export default getSDKInstance;
